import styled from 'styled-components'

export const TermStyled = styled.dt`
  color: ${(props) => props.theme.labelTextColour};
  font-size: ${(props) => props.theme.labelFontSize};
  font-weight: ${(props) => props.theme.labelFontWeight};
  font-family: ${(props) => props.theme.labelFontFamily};
  margin-bottom: 6px;
  text-align: left;
  display: block;
  line-height: 100%;
`

export const DescStyled = styled.dd`
  margin: 0;
  margin-bottom: 16px;
  font-family: ${(props) => props.theme.fontFamily};
  font-size: ${(props) => props.theme.generalFontSize};
`

export const DefinitionList = styled.dl``
